// extracted by css-extract-rspack-plugin
export default {"cell-title":"h38PzB","cellTitle":"h38PzB","pending-deletion":"rnkaF2","pendingDeletion":"rnkaF2","badge":"Vo05gW"};